import { Group, Text, UnstyledButton } from '@mantine/core';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ClipboardList, Folder, Bell } from 'tabler-icons-react';

import styles from './BottomNav.module.css';

/**
 * Mobile bottom navigation – shown on small screens when sidebar is hidden.
 */
export default function BottomNav() {
  const location = useLocation();
  const isDashboard =
    location.pathname === '/dashboard' ||
    (location.pathname.startsWith('/dashboard/') && !location.pathname.startsWith('/dashboards'));

  const openNotifications = () => {
    document.querySelector<HTMLButtonElement>('[aria-label="Notifications"]')?.click();
  };

  return (
    <nav className={styles.bottomNav} aria-label="Bottom navigation">
      <Link
        to="/dashboard"
        className={styles.navItem}
        aria-current={isDashboard ? 'page' : undefined}
      >
        <Group spacing={4} position="center">
          <Home size={22} />
          <Text size="xs">Overview</Text>
        </Group>
      </Link>
      <Link
        to="/my-tasks"
        className={styles.navItem}
        aria-current={location.pathname === '/my-tasks' ? 'page' : undefined}
      >
        <Group spacing={4} position="center">
          <ClipboardList size={22} />
          <Text size="xs">My Tasks</Text>
        </Group>
      </Link>
      <Link
        to="/project-management"
        className={styles.navItem}
        aria-current={location.pathname === '/project-management' ? 'page' : undefined}
      >
        <Group spacing={4} position="center">
          <Folder size={22} />
          <Text size="xs">Projects</Text>
        </Group>
      </Link>
      <UnstyledButton className={styles.navItem} onClick={openNotifications}>
        <Group spacing={4} position="center">
          <Bell size={22} />
          <Text size="xs">Alerts</Text>
        </Group>
      </UnstyledButton>
    </nav>
  );
}
